import { Box, BoxProps, Stack } from '@mui/material';
import { FC } from 'react';
import { EmailTrackingByDocumentQueryVariables } from '../../../../../graphql/generatedModel';
import { IOrderTypeDescription } from '../../../../../pages/order/edit/states/orderDetails/orderDetails.state';
import { UseFormReturn } from 'react-hook-form';
import { CustomerHeader } from './components/сustomerHeader/сustomerHeader.component';
import { StatusChips } from './components/statusChips/statusChips.component';
import { Address } from './components/address/address.component';

export const LeftColumn: FC<ILeftColumn> = (props) => {
  const {
    leftColumnProps,
    customerName,
    infoTip,
    emailTip,
    orderType,
    isEmailServiceForInvoice,
    register,
    addressNameField,
    addressValue,
    readOnlyAddress,
    isAddressPinned,
  } = props;

  return (
    <Box sx={{ overflow: 'hidden' }} {...leftColumnProps}>
      <CustomerHeader {...{ customerName, infoTip, emailTip }} />
      <Stack
        sx={{
          alignItems: 'flex-start',
        }}
      >
        <StatusChips {...{ orderType, isEmailServiceForInvoice }} />
        <Address
          {...{ addressValue, addressNameField, register, readOnlyAddress, isAddressPinned }}
        />
      </Stack>
    </Box>
  );
};

export interface ILeftColumn {
  leftColumnProps?: BoxProps;
  customerName: string;
  infoTip?: {
    text?: string | null;
    readonly?: boolean;
    customerId?: string;
  };
  emailTip?: {
    params: EmailTrackingByDocumentQueryVariables;
    message: string;
  };
  orderType?: IOrderTypeDescription;
  isEmailServiceForInvoice?: boolean;
  register?: UseFormReturn<any>['register'];
  addressNameField?: string;
  addressValue?: string;
  readOnlyAddress?: boolean;
  isAddressPinned?: boolean;
}
